import {
  CENTRAL_QUARTER_PREFIX,
  COMMON_BUILDING_TOKENS,
  FLAG_PREFIX,
  KEY_POINT_TOKENS,
  TERRAIN_TOKENS,
  TOKEN_NAME_MAPPING,
} from '../constants/tokens';
import {NEUTRAL_PLAYER_COLOR} from '../constants/players';
import {PLAYER_COLORS} from './colors';

/**
 * Схема поля на страницах выбора карты и настройки локальной партии. Это не
 * уменьшенная сцена: жетон здесь — шестиугольник в цвете настоящего жетона и
 * простая метка, различимые и при ячейке в пять точек.
 */

// Метки поверх шестиугольника жетона (см. buildFieldPreviewModel)
export const FIELD_PREVIEW_MARKS = {
  INNER_HEX: 'inner_hex',
  PEAK: 'peak',
  FLAG: 'flag',
};

// Прочие строения (специальные и то, чего схема еще не знает): на полях партий
// их нет, но поле с ними не должно терять ячейку
export const FIELD_PREVIEW_OTHER_TOKEN = 'other';

// Порядок — порядок отрисовки. Цвета взяты с картинок жетонов
export const FIELD_PREVIEW_TOKEN_STYLES = {
  [TERRAIN_TOKENS.MOUNTAIN]: {fill: '#45484d', mark: FIELD_PREVIEW_MARKS.PEAK, markFill: '#c3c7cc'},
  [COMMON_BUILDING_TOKENS.ROAD]: {fill: '#8a7a63'},
  [COMMON_BUILDING_TOKENS.QUARTER]: {fill: '#a4602f'},
  [COMMON_BUILDING_TOKENS.FARM]: {fill: '#6f9a3a'},
  [COMMON_BUILDING_TOKENS.BARRACKS]: {fill: '#8c3a3a'},
  [KEY_POINT_TOKENS.MINE]: {fill: '#c9973f'},
  [KEY_POINT_TOKENS.SUPER_MINE]: {fill: '#ffc61a', mark: FIELD_PREVIEW_MARKS.INNER_HEX, markFill: '#6b4700'},
  [KEY_POINT_TOKENS.RUINS]: {fill: '#c7cbcf'},
  [KEY_POINT_TOKENS.SUPER_RUINS]: {fill: '#59606a', mark: FIELD_PREVIEW_MARKS.INNER_HEX, markFill: '#f2f4f6'},
  [FIELD_PREVIEW_OTHER_TOKEN]: {fill: '#7d5aa6'},
};

// Центральный квартал — дерево квартала и флаг владельца на нем
export const FIELD_PREVIEW_CENTRAL_QUARTER_FILL = FIELD_PREVIEW_TOKEN_STYLES[COMMON_BUILDING_TOKENS.QUARTER].fill;

// Ячейка под стартовым флагом подкрашена цветом игрока: так зона видна и
// там, где сам флаг уже не разобрать
export const FIELD_PREVIEW_FLAG_CELL_OPACITY = 0.45;

export const FIELD_PREVIEW_UNIT_LEGEND_ID = 'unit';
export const FIELD_PREVIEW_FLAG_LEGEND_ID = 'flag';
export const FIELD_PREVIEW_CENTRAL_QUARTER_LEGEND_ID = 'central_quarter';

const NEUTRAL_CENTRAL_QUARTER_TOKEN = `${CENTRAL_QUARTER_PREFIX}${NEUTRAL_PLAYER_COLOR}`;

// Подписи условных обозначений. token — чем в легенде нарисован образец
export const FIELD_PREVIEW_LEGEND = [
  {id: FIELD_PREVIEW_FLAG_LEGEND_ID, label: 'Стартовый флаг', token: `${FLAG_PREFIX}${PLAYER_COLORS.BLUE}`},
  {id: FIELD_PREVIEW_UNIT_LEGEND_ID, label: 'Нейтральный отряд'},
  {id: FIELD_PREVIEW_CENTRAL_QUARTER_LEGEND_ID, label: 'Нейтральный город', token: NEUTRAL_CENTRAL_QUARTER_TOKEN},
  ...[
    COMMON_BUILDING_TOKENS.QUARTER,
    KEY_POINT_TOKENS.MINE,
    KEY_POINT_TOKENS.SUPER_MINE,
    KEY_POINT_TOKENS.RUINS,
    KEY_POINT_TOKENS.SUPER_RUINS,
    COMMON_BUILDING_TOKENS.FARM,
    COMMON_BUILDING_TOKENS.BARRACKS,
    COMMON_BUILDING_TOKENS.ROAD,
    TERRAIN_TOKENS.MOUNTAIN,
  ].map((token) => ({id: token, label: TOKEN_NAME_MAPPING[token], token})),
];

// Стартовый состав полей партий: то, что встречается на боевых картах. Ферма,
// казарма и дорога в общей легенде страницы выбора только шумели бы — на
// странице партии легенда и так собирается по самому полю
export const FIELD_PREVIEW_COMMON_LEGEND_IDS = [
  FIELD_PREVIEW_FLAG_LEGEND_ID,
  FIELD_PREVIEW_UNIT_LEGEND_ID,
  FIELD_PREVIEW_CENTRAL_QUARTER_LEGEND_ID,
  COMMON_BUILDING_TOKENS.QUARTER,
  KEY_POINT_TOKENS.MINE,
  KEY_POINT_TOKENS.SUPER_MINE,
  KEY_POINT_TOKENS.RUINS,
  KEY_POINT_TOKENS.SUPER_RUINS,
  TERRAIN_TOKENS.MOUNTAIN,
];
